export const locations = [
  {
    id: 1,
    country: 'switzerland',
    name: 'Basel',
    thumb: 'basel'
  }

]